import React from 'react';
import { makeStyles } from '@mui/styles';
import { Alert } from '@mui/material';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    alignItems: 'center',
  },
}));

export default function ActionAlerts({ open, handleClose, text, severity, link }) {
  const classes = useStyles();

  return (
    <>
      {open && (
        <Alert
          className={classes.root}
          color={severity === 'error' ? 'error' : 'success'}
          severity={severity}
          onClose={handleClose}
        >
          {text} {link}
        </Alert>
      )}
    </>
  );
}
